<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group :submissionId="submissionId" :formLabel="'Field'" />
      <hr />
      <project-tissue-crop-form-groups :submissionId="submissionId" :cropOptions="crop_options" :cropStageOptions="cropstage_options" />
      <hr />
      <div v-if="samples && samples.length">
        <template v-for="(sample, index) in samples">
          <project-tissue-sample-form-groups :key="index" :submissionId="submissionId" :sampleId="sample.test_package_sample_id" :addOns="addOns" />
        </template>
      </div>
      <hr />
      <turn-around-select :submissionId="submissionId" :turnArounds="turnArounds" />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="question" />
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import AddOnSelect from "../../misc/AddOnSelect";
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectTissueCropFormGroups from "./ProjectTissueCropFormGroups";
import ProjectTissueSampleFormGroups from "./ProjectTissueSampleFormGroups";
import ServiceQuestion from "../../misc/ServiceQuestion";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";

export default {
  name: "ProjectTissueSubmissionForm",
  components: {
    AddOnSelect,
    ProjectFieldFormGroup,
    ProjectTissueCropFormGroups,
    ProjectTissueSampleFormGroups,
    ServiceQuestion,
    TurnAroundSelect
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: ""
    },
    addOns: {
      type: Array,
      default: () => []
    },
    turnArounds: {
      type: Array,
      default: () => []
    },
    serviceQuestions: {
      type: Array,
      default: () => []
    },
    managedLists: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission"
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    isValid() {
      return this.$v && !this.$v.$invalid;
    },
    crop_options() {
      return this.createOptionList(
        this.managedLists.find(
          item => item.sub_type === "tissue" && item.list === "type"
        ).attribute_lists,
        "crop"
      );
    },
    cropstage_options() {
      return this.createOptionList(
        this.managedLists.find(
          item => item.sub_type === "tissue" && item.list === "growth_stage"
        ).attribute_lists,
        "cropstage"
      );
    }
  },
  validations: {
    currentSubmission: {
      test_package_id: { required },
      turnaround_id: { required },
      identifier: { required },
      event_code: { required },
      samples: { required, minLength: minLength(1) }
    }
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    createOptionList(list, field) {
      return {
        options: list.map(item => {
          return { id: item.id, name: item.value, parent_id: item.parent_id };
        }),
        field
      };
    }
  }
};
</script>
